import { AdInfo } from "~/app/core/model/ad-info";

export class SponsorInfo {
    id: number = null;
    name: string = "";
    description?: string = "";
    addressStreet?: string;
    addressCity?: string;
    addressState?: string;
    addressZip?: string;
    companyPhone?: string;
    logoImageUrl: string = "";
    logoImageHash?: string = "";
    destinationUrl: string = "";
    videoUrl: string = "";
    videoHash?: string = "";
    longitude?: number;
    latitude?: number;
    showThankYou?: boolean = true;
    showSponsorPage?: boolean = true;
    ad: AdInfo;
}
